import axios from 'axios';

import apiManager from './AxiosInstance';
import newApiManager from './NewAxiosInstance';
import { OneStopServiceRequestData } from '@/components/Products/Sale/OneStopServiceRequest';
import { SALES_TYPE_ASSURANCE } from '@/const/products';

export const getTerm = () => {
  return apiManager.get('/api/v1/public/terms');
};

// export const getPublicPriceTrend = async (queryParams: URLSearchParams) => {
//   const res = await apiManager.get('/api/v1/public/prices', { params: queryParams });
//   return res.data;
// };

export const getPublicPriceTrend = async (queryParams: URLSearchParams) => {
  const res = await newApiManager.get('/api/v1/public/prices/prices-info', { params: queryParams });
  return res.data;
};

// export const getPriceTrend = async (queryParams: URLSearchParams) => {
//   const res = await apiManager.get('/api/v1/prices', { params: queryParams });
//   return res.data;
// };

export const getPriceTrend = async (queryParams: URLSearchParams) => {
  const res = await newApiManager.get('/api/v1/prices/prices-info', { params: queryParams });
  return res.data;
};

export const getProductList = (queryParams: URLSearchParams) => {
  return newApiManager.get('/api/v1/public/products?', { params: queryParams });
};

export const getNotifications = () => {
  return apiManager.get('/api/v1/notifications');
};

export const deleteNotification = async (id: number): Promise<any> => {
  const { data } = await apiManager.delete(`/api/v1/notifications/${id}`);
  return id;
};

export const getInterestProductsNotificationSettings = () => {
  return apiManager.get('/api/v1/interest-product-notification-settings');
};

export const deleteInterestProductNotificationSettings = async (id: number): Promise<any> => {
  return await apiManager.delete(`/api/v1/interest-product-notification-settings/${id}`);
};
export const postInterestProductNotificationSettings = (request: InterestProductNotificationSettingsRequest) => {
  return apiManager.post('/api/v1/interest-product-notification-settings', request);
};

export const postOneStopService = (request: OneStopServiceRequestData) => {
  return newApiManager.post('/api/v1/one-stop-services', request);
};

export const patchProducts = (request: ProductRegisterRequest) => {
  return newApiManager.patch(`/api/v1/products/${request.id}`, {
    modelId: request?.modelId,
    modelDetail: request?.modelDetail,
    tons: request?.tons,
    loaded: request?.loaded,
    loadedDetail: request?.loadedDetail,
    loadedInnerLength: request?.loadedInnerLength,
    loadedInnerArea: request?.loadedInnerArea,
    loadedInnerHeight: request?.loadedInnerHeight,
    axis: request?.axis,
    type: request?.type,
    speedCheck: request?.speedCheck,
    transmission: request?.transmission,
    distance: request?.distance,
    fuel: request?.fuel,
    power: request?.power,
    color: request?.color,
    garage: request?.garage,
    area1: request?.area1,
    area2: request?.area2,
    area3: request?.area3,
    accident: request?.accident,
    accidentContents: request?.accidentContents,
    maintenanceData: request?.maintenanceData,
    transportGoods: request?.transportGoods,
    transportStartLocate: request?.transportStartLocate,
    transportEndLocate: request?.transportEndLocate,
    tireStatus: request?.tireStatus,
    carOption: request?.carOption,
    detailContent: request?.detailContent,
    certificateImageUrl: request.certificateImageUrl,
    frontSideImageUrl: request.frontSideImageUrl,
    backSideImageUrl: request.backSideImageUrl,
    frontImageUrl: request.frontImageUrl,
    backImageUrl: request.backImageUrl,
    tireImageUrl: request.tireImageUrl,
    engineImageUrl: request.engineImageUrl,
    insideImageUrl: request.insideImageUrl,
    dashboardImageUrl: request.dashboardImageUrl,
    sheetImageUrl: request.sheetImageUrl,
    optionImageUrls: request.optionImageUrls,
    year: request?.year,
    price: request?.price,
    status: request?.status,
    isSaleLicense: request?.isSaleLicense,
    evidentiaryDocumentsUrl1: request?.evidentiaryDocumentsUrl1,
    evidentiaryDocumentsUrl2: request?.evidentiaryDocumentsUrl2,
    evidentiaryDocumentsUrl3: request?.evidentiaryDocumentsUrl3,
    evidentiaryDocumentsUrl4: request?.evidentiaryDocumentsUrl4,
    evidentiaryDocumentsUrl5: request?.evidentiaryDocumentsUrl5,
  });
};

export const patchProductsStatus = (request: { productId: number; status: string }) => {
  return newApiManager.patch(`/api/v1/products/${request.productId}`, { status: request.status });
};

export const getJobList = (queryParams?: URLSearchParams) => {
  return apiManager.get('/api/v1/public/job', { params: queryParams });
};

export const getJobFilterInfo = () => {
  return apiManager.get('/api/v1/public/job/filter-info');
};

export const downloadContractFile = (request: { contractId: number; formData: FormData }) => {
  return apiManager.post(`/api/v1/contracts/${request.contractId}/download`, request.formData);
};

export const postDriveVehicleInfo = (request: VehicleInfoRequest) => {
  return apiManager.post('/api/v1/drive-vehicle-info', request);
};

export const patchDriveVehicleInfo = (request: { id: number; requestData: VehicleInfoRequest }) => {
  return apiManager.patch(`/api/v1/drive-vehicle-info/${request.id}`, request.requestData);
};

export const getDriveMyVehicleInfo = () => {
  return apiManager.get('/api/v1/drive-vehicle-info/my');
};

export const getFuelingHistory = (queryParams?: URLSearchParams) => {
  return apiManager.get('/api/v1/fueling-history', { params: queryParams });
};

export const postDriveHistory = (request: DriveHistoryForm) => {
  return apiManager.post(`/api/v1/drive-history`, request);
};

export const patchDriveHistory = (request: { id: number; body: DriveHistoryForm }) => {
  return apiManager.patch(`/api/v1/drive-history/${request.id}`, request.body);
};

export const deleteFuelingHistory = async (id: number): Promise<any> => {
  return apiManager.delete(`/api/v1/fueling-history/${id}`);
};

export const postFuelingHistoryReceipt = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  return apiManager.post('/api/v1/fueling-history/receipt', formData);
};

export const postFuelingHistory = (request: FuelingForm) => {
  return apiManager.post('/api/v1/fueling-history', request);
};

export const patchFuelingHistory = (request: { id: string; body: FuelingForm }) => {
  return apiManager.patch(`/api/v1/fueling-history/${request.id}`, request.body);
};

export const getDriveHistory = (queryParams: URLSearchParams) => {
  return apiManager.get('/api/v2/drive-history', { params: queryParams });
};

export const deleteTransportInfo = (id: number) => {
  return apiManager.delete(`/api/v1/drive-history/${id}`);
};

export const patchTransportInfo = (request: { id: string; body: TransportInfoRequest }) => {
  return apiManager.patch(`/api/v1/transport-info/${request.id}`, request.body);
};

export const getTransportInfoOutstandingAmount = (queryParams: URLSearchParams) => {
  return apiManager.get('/api/v1/transport-info/outstanding-amount', { params: queryParams });
};

export const patchTransportInfoOutstandingAmount = (request: TransportInfoOutstandingAmountModifyRequest) => {
  return apiManager.patch(`/api/v1/transport-info/outstanding-amount`, request);
};

export const getLicenseList = (queryParams?: URLSearchParams) => {
  return newApiManager.get('/api/v1/public/license', { params: queryParams });
};

export const postProductInquiry = (request: ProductPurchasingInquiryRequest) => {
  return newApiManager.post('/api/v1/public/product-inquiry', request);
};

export const postInterestProducts = (productId: number) => {
  return apiManager.post('/api/v1/interest-products', { productId });
};

export const deleteInterestProducts = (interestProductId: number) => {
  return apiManager.delete(`/api/v1/interest-products/${interestProductId}`);
};

export const getInterestProducts = async (productsStatus?: string | string[]) => {
  const res = await apiManager.get('/api/v1/interest-products', { params: { productsStatus } });
  return res.data;
};

export const patchMemberNotifications = (memberNotificationsId: number) => {
  return apiManager.patch(`/api/v1/member-notifications/${memberNotificationsId}`);
};

export const postProductInquiryCall = (productId: number) => {
  return apiManager.post(`/api/v1/products/${productId}/inquiry/call`);
};

export const getSearchHistory = (queryParams?: URLSearchParams) => {
  return apiManager.get('/api/v1/search-history', { params: queryParams });
};

export const deleteSearchHistory = (searchHistoryId: number) => {
  return apiManager.delete(`/api/v1/search-history/${searchHistoryId}`);
};

export const getNotice = async (page: number) => {
  const res = await apiManager.get('/api/v1/notice', { params: { page } });
  return res.data;
};

export const getNoticeDetail = async (id: string | undefined) => {
  const res = await apiManager.get(`/api/v1/notice/${id}`);
  return res.data;
};

export const patchProductsAfterPriceSearch = async (productId: string | undefined) => {
  const res = await apiManager.patch(`/api/v1/products/${productId}/after-price-search`);
  return res.data;
};

export const getBanner = async () => {
  const res = await newApiManager.get('/api/v1/public/banners');
  return res.data;
};

export const patchBanner = async (bannerId: number) => {
  const res = await newApiManager.patch(`/api/v1/public/bannersHitCount/${bannerId}`);
  return res.data;
};

export const getAdminSetting = async (): Promise<AdminSetting> => {
  const res = await newApiManager.get('/api/v1/public/adminSetting');
  return res.data;
};

export const getAdvertisements = async (): Promise<Advertisement[]> => {
  const res = await newApiManager.get('/api/v1/public/advertisement');
  return res.data;
};

export const getCounts = async () => {
  const res = await newApiManager.get('/api/v1/public/counts');
  return res.data;
};

export const getLiveStream = async () => {
  const res = await apiManager.get('/api/v1/public/youtube-videos/info');
  return res.data;
};

export const getAssuranceProducts = async () => {
  const res = await newApiManager.get(`/api/v1/public/products?salesType=${SALES_TYPE_ASSURANCE}`);
  return res.data;
};

export const getRecommendProducts = async () => {
  const res = await apiManager.get('/api/v1/products/recommend');
  return res.data;
};

export const postReferralCode = (request: { referralCode: string }) => {
  return apiManager.post('/api/v1/referral-codes', request);
};

export const getYoutubeVideos = async () => {
  const res = await apiManager.get('/api/v1/public/youtube-videos');
  return res.data;
};

export const getReviews = async (): Promise<ProductReview[]> => {
  const res = await newApiManager.get('/api/v1/public/review');
  return res.data;
};

export const getHorsepower = async (params: {
  manufacturer: string;
  modelName: string;
  tons: string;
  horsePower: string;
}) => {
  const res = await axios.get('https://api.mchans.co.kr/zigtruck/horsepower/', { params });
  return res.data;
};
